/**
 * Query-string handoff keys for Urgent Care booking (GM-6958).
 *
 * Location / slot response shapes live in
 * `@/lib/store/api/urgentCareLocationsApi` (single `UrgentCareLocation` type).
 * Aligns with Core checkout for location + slot (`location_id`, `appointment_time`).
 * Walk-in uses `walk_in` in the FE handoff query; checkout maps that to Core's
 * `on_demand` body field.
 */
export const URGENT_CARE_BOOKING_QUERY = {
    locationId: 'location_id',
    appointmentTime: 'appointment_time',
    /** Walk-in / on-demand when `"true"` or `"1"`. */
    walkIn: 'walk_in',
    reschedule: 'reschedule',
} as const
